import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import style from "./toastify.module.css"

let lastToastId = null;

export const Toastify = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      limit={1}
      newestOnTop
      pauseOnFocusLoss={false}
      closeOnClick
      toastContainerClassName={style.customContainer}
      draggable
      bodyClassName={style.customToastBody}
      hideProgressBar={true}
      closeButton={({ closeToast }) => (
        <button onClick={closeToast} className={style.closeButton}>
          ×
        </button>
      )}
      toastClassName={({ type }) => {
        const base = style.customToast;
        const typeClass =
          {
            success: style.success,
            error: style.error,
            info: style.info,
            warning: style.warning,
            warn: style.warning,
          }[type] || "";
        return `${base} ${typeClass}`;
      }}
    />
  );
};

export const showToast = (message, type = "default") => {
  // Callers often forward `err?.response?.data?.message` straight through,
  // which is undefined for network errors / non-API failures -- fall back
  // instead of rendering a blank toast body. Several existing call sites
  // across the app also call showToast() with no arguments at all on a
  // non-error path as a deliberate silent no-op (e.g. after a background
  // filter refresh) -- that's existing, intentional UX, so only "error"
  // gets a forced fallback; a blank non-error message still renders nothing.
  const body = message || (type === "error" ? "Something went wrong" : "");

  if (!body) return;

  if (lastToastId && toast.isActive(lastToastId)) {
    toast.dismiss(lastToastId);
  }
  // Errors get more time on screen than the container's 3s default — they're
  // often a specific reason the user needs to actually read (e.g. "in use by
  // N items"), not just a passing confirmation.
  const options = { icon: false, ...(type === "error" ? { autoClose: 6000 } : {}) };

  switch (type) {
    case "success":
      lastToastId = toast.success(body, options);
      break;
    case "error":
      lastToastId = toast.error(body, options);
      break;
    case "info":
      lastToastId = toast.info(body, options);
      break;
    case "warn":
    case "warning":
      lastToastId = toast.warning(body, options);
      break;
    default:
      lastToastId = toast(body, options);
  }
};
